var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports"},[_c('ReportWinloseComponent',{attrs:{"ref-key-text":_vm.refKeyText,"title":_vm.title,"url-path":_vm.urlPath,"route-name":_vm.routeName,"is-simple":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }